<template>
  <div>
    <custom-modal
      ref="formModal"
      class="form-modal"
      :visible.sync="visible"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
    >
      <div class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <h1 class="modal-title col-2">Bulk Create Phone Numbers</h1>
          <div v-if="!bulkOperationComplete" class="modal-actions col-2">
            <el-button
              v-if="bulkNumbers.length"
              type="primary"
              @click="handleCreate"
            >
              Create
            </el-button>
            <el-button type="default" @click="handleClose">Cancel</el-button>
          </div>
          <div v-else class="modal-actions col-2">
            <el-button type="default" @click="handleClose">Close</el-button>
          </div>
        </div>
      </div>

      <div id="extension-summary-block">
        <div class="inline-form-group mt-20">
          <bulk-example :filePath="bulkFilePath">
            <el-button
              slot="hoverRef"
              type="primary"
              :disabled="bulkOperationComplete"
              @click="startImport"
            >
              Import CSV
            </el-button>
          </bulk-example>
          <el-button
            class="ml-5"
            type="danger"
            icon="el-icon-close"
            v-if="fileSelected"
            @click="closeImporting"
          />
          <el-button
            class="ml-5"
            type="primary"
            icon="el-icon-check"
            v-if="csvReady"
            @click="addToBulk"
          />
        </div>
        <div class="csv-import" v-show="importVisible">
          <upload-csv
            :key="uploadCsvKey"
            ref="fileButton"
            v-model="parsedCSV"
            :map-fields="[
              { label: 'Phone Number', key: 'number' },
              { label: 'Tenant ID', key: 'tenantId' },
            ]"
            @input="csvReady = true"
            @invalidFileType="handleInvalidFileType"
            @fileSelected="submitForMapping"
            :headers="true"
          />
        </div>
      </div>
      <div id="operation-summary" v-if="bulkOperationComplete">
        <div v-if="!!successCount" class="mb-10 inline-form__group">
          <el-button type="success" size="mini" icon="el-icon-check">
            <span class="black-text">
              {{ successCount }}
            </span>
          </el-button>
        </div>
        <div v-if="!!errorCount" size="mini" class="inline-form__group">
          <el-button type="danger" icon="el-icon-close">
            <span class="black-text">
              {{ errorCount }}
            </span> </el-button
          >&nbsp;
        </div>
      </div>
      <vxe-grid
        v-if="bulkNumbers.length"
        class="modal-summary-table mb-10"
        border="inner"
        ref="xGrid"
        height="400"
        auto-resize
        empty-text="No Data"
        show-overflow="tooltip"
        highlight-hover-row
        :data="bulkNumbers"
        :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
        :columns="tableColumns"
      />
    </custom-modal>
  </div>
</template>

<script>
import uploadCSV from "@/components/upload-csv";
import customModal from "@/components/CustomModalComponent";
import bulkExample from "@/components/bulkExample";
import { mapActions } from "vuex";

export default {
  name: "bulkCreateExtensions",
  props: {
    visible: { default: false },
    numberFormatter: { required: true },
  },

  components: {
    UploadCsv: uploadCSV,
    customModal,
    bulkExample,
  },

  data() {
    return {
      bulkFilePath:
        "https://global-app.s3.amazonaws.com/omnia-assets/bulk_create_phone_numbers_example.csv",
      uploadCsvKey: "",
      bulkNumbers: [],
      bulkOperationComplete: false,
      closeModalContext: "Cancel and Discard Unsaved Changes?",
      fieldsValid: false,
      parsedCSV: null,
      importVisible: false,
      csvReady: false,
      fileSelected: false,
      successCount: 0,
      errorCount: 0,
      form: {
        extNumber: "",
        mac: "",
        phoneModelName: "",
        phonebook: "",
      },
      tableColumns: [
        {
          field: "number",
          title: "Phone Number",
          minWidth: 75,
          slots: {
            default: ({ row }) => {
              return [
                <span class="first-table-column">
                  {this.numberFormatter(row.number)}
                </span>,
              ];
            },
          },
        },
        {
          field: "tenantId",
          title: "Tenant ID",
          minWidth: 75,
          showOverflow: true,
        },
        {
          field: "errorMessage",
          title: "Error",
          minWidth: 125,
          showOverflow: true,
        },
        {
          field: "status",
          title: "",
          slots: {
            default: ({ row }) => {
              return [
                <div>
                  {row.status === "done" && (
                    <el-button
                      type="success"
                      class="table-action-button"
                      icon="el-icon-check"
                      size="mini"
                    />
                  )}
                  {row.status === "loading" && (
                    <el-button
                      type="primary"
                      class="table-action-button"
                      icon="el-icon-loading"
                      size="mini"
                    />
                  )}
                  {row.status === "error" && (
                    <el-tooltip placement="top" content={row.errorMessage}>
                      <el-button
                        type="danger"
                        class="table-action-button"
                        icon="el-icon-close"
                        size="mini"
                      />
                    </el-tooltip>
                  )}
                </div>,
              ];
            },
          },
        },
        {
          field: "remove",
          title: "",
          slots: {
            default: ({ row, rowIndex }) => {
              return [
                <el-button
                  onClick={() => this.removeFromBulk(rowIndex)}
                  class="table-action-button"
                  type="default"
                  size="small"
                  icon="el-icon-minus"
                />,
              ];
            },
          },
        },
      ],
    };
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    fieldLength() {
      let concat = "";
      Object.keys(this.form).forEach((key) => {
        concat += this.form[key];
      });
      return concat.length;
    },
  },

  watch: {
    fieldLength() {
      if (this.fieldLength) {
        this.fieldsValid = true;
      } else {
        this.fieldsValid = false;
      }
    },

    bulkOperationComplete(val) {
      if (val) {
        this.closeModalContext = `Close the Bulk Create modal?`;
      }
    },
  },

  methods: {
    ...mapActions("dids", {
      createNumber: "create",
    }),

    getRandomKey() {
      const randomString = () => Math.random().toString(36).slice(2);
      return `${randomString()}-${randomString()}$${randomString()}`;
    },

    handleCreate() {
      this.$confirm("Create Phone Numbers?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      })
        .then(async () => {
          await this.saveNumbers();
        })
        .catch(() => true);
    },

    async saveNumbers() {
      if (this.bulkNumbers.length) {
        for (let i = 0; i < this.bulkNumbers.length; i++) {
          this.bulkNumbers[i].status = "loading";
          await this.wait(250);

          const { number, callerId, tenantId } = this.bulkNumbers[i];

          if (!number) {
            this.bulkNumbers[i].errorMessage = "Phone Number cannot be empty!";
            this.bulkNumbers[i].status = "error";
            this.errorCount++;
            continue;
          }

          if (!tenantId) {
            this.bulkNumbers[i].errorMessage = "Tenant ID cannot be empty!";
            this.bulkNumbers[i].status = "error";
            this.errorCount++;
            continue;
          }

          /**
           * Go ahead and process the create
           */
          const createData = {
            numbers: [number],
            tenantId,
            orderType: "MANUAL",
          };

          this.createNumber(createData)
            .then(() => {
              this.bulkNumbers[i].status = "done";
              this.successCount++;
            })
            .catch((error) => {
              if (
                error.hasOwnProperty("errors") &&
                Object.keys(error.errors).length !== 0
              ) {
                this.bulkNumbers[i].errorMessage =
                  error.errors[Object.keys(error.errors)[0]];
              } else {
                this.bulkNumbers[i].errorMessage = error.message;
              }
              this.bulkNumbers[i].status = "error";
              this.errorCount++;
            });
        }
        this.bulkOperationComplete = true;
      }
    },

    async wait(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },

    handleClose() {
      this.$confirm(`${this.closeModalContext}`, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          this.cancelOperation();
        })
        .catch(() => true);
    },

    cancelOperation() {
      this.$emit("modalClosed");
      this.clearFormFields();
      this.bulkNumbers = [];
    },

    clearFormFields() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = typeof this.form[key] === typeof [] ? [] : "";
      });
      this.bulkOperationComplete = false;
      this.closeModalContext = "Cancel and Discard Unsaved Changes?";
      this.bulkNumbers = [];
      this.fieldsValid = false;
      this.parsedCSV = null;
      this.importVisible = false;
      this.csvReady = false;
      this.fileSelected = false;
      this.successCount = 0;
      this.errorCount = 0;
    },

    closeImporting() {
      this.parsedCSV = null;
      this.csvReady = false;
      this.fileSelected = false;
      this.importVisible = false;
      this.$refs.fileButton.sample = null;
      this.$refs.fileButton.fileSelected = false;
      this.$refs.fileButton.map = {};
      this.$refs.fileButton.isValidFileMimeType = false;
      this.$refs.fileButton.form = { csv: null };
      let fileButton = document.querySelector(".form-control-file");
      fileButton.value = null;
    },

    addToBulk() {
      const values = [...this.parsedCSV];
      for (let i = 0; i < values.length; i++) {
        this.bulkNumbers.push({
          ...values[i],
          status: "",
          errorMessage: "",
        });
      }
      this.closeImporting();
    },

    startImport() {
      this.importVisible = true;
      const fileButton = document.querySelector(".form-control-file");
      fileButton.click();
    },

    removeFromBulk(index) {
      this.bulkNumbers.splice(index, 1);
    },

    submitForMapping() {
      this.fileSelected = true;
      this.$refs.fileButton.load();
    },

    handleInvalidFileType() {
      this.closeImporting();
      this.uploadCsvKey = this.getRandomKey();
      this.$notify({
        title: "Invalid file type",
        message: "Please import csv files only!",
        type: "error",
      });
    },
  },

  created() {
    this.uploadCsvKey = this.getRandomKey();
  },

  beforeDestroy() {
    this.$refs.formModal.$destroy();
  },
};
</script>

<style lang="scss" scoped>
#extension-summary-block {
  max-width: 600px;
  margin: 30px auto;
}

#operation-summary {
  max-width: 600px;
  margin: 10px auto;

  span {
    font-size: 18px;
  }
}

#error-summary {
  max-width: 600px;
  margin: 30px auto;
}

.modal-summary-table {
  max-width: 600px;
  margin: 20px auto;
}

.vue-csv-uploader {
  input[type="file"] {
    display: none;
  }
}
</style>
